export default __webpack_public_path__ + "static/media/tom.927d95f0.ogg";